module.exports = __webpack_public_path__ + "img/pic_tx_ai.3a2d17e8.png";